import { render, staticRenderFns } from "./Denied.vue?vue&type=template&id=5fb6b0f4&scoped=true&"
import script from "./Denied.vue?vue&type=script&lang=js&"
export * from "./Denied.vue?vue&type=script&lang=js&"
import style0 from "./Denied.vue?vue&type=style&index=0&id=5fb6b0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6b0f4",
  null
  
)

export default component.exports